
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"data-name":"Background copy","width":"24","height":"24","xlink:href":"data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAA6UlEQVRIiaVW0RLDIAgT/v+f2bmrPU0TYB1vg5gwQKxFxKjMzCgoIqw8qwQUqTIlRgWQHDFmPHEm4v+Qz9geZ//6EFiApGxUOBNxDPxKXok4Olh9M/IZW3Em8ugBElaZIw4xh0BGIKYt/f3FzLNIgMAOOeJXnJZITUhGrhL07BCzrCcsGbwHr8mVn93k1+Qs7syZTUfnIh7+q+P3JFXTUZHuHHP5PUrUrW2nlEM1uZqOakwfAmyPr1VcrWslsjgdHfvyQquavdf+9pEM6YOjyMlaORytJ5MJdsilQCUihPuPfles/GwZY3wA2anaCC2rRVEAAAAASUVORK5CYII="}})])
          )
        }
      }
    